export var StorageKeys;
(function (StorageKeys) {
    StorageKeys["ApolloSession"] = "[session]apolloSession";
    StorageKeys["LegacySession"] = "[session]legacySession";
})(StorageKeys || (StorageKeys = {}));
